<script setup lang="ts">
  import { appRouteDefinitions } from '@gat-ship/lib/router'
  import { provideAppModal } from '@gat-ship/vue-components'
  import { defineAsyncComponent, ref } from 'vue'
  import appSplashScreen from './components/app-splash-screen.vue'
  import ErrorDialog from './components/error-dialog.vue'
  import LeaveDialog from './components/unsaved-changes-dialog.vue'
  import { useThemeConfig } from './composables/useThemeConfig'
  import {
    useAppInitialization,
    useStartupState
  } from '@gat-ship/lib/app-state'
  import { AppShell, ConfirmDialogProvider } from '@gat-ship/shared'
  import AppMainMenu from './layout/app-main-menu.vue'
  import { LoadingProvider } from '@gat-ship/vue-components'
  import { NotificationProvider } from '@gat-ship/notifications'
  import AppContexts from './AppContexts.vue'

  const SupportSessionHeader = defineAsyncComponent(() =>
    import('@gat-ship/support').then((m) => m.SupportSessionHeader)
  )

  const appReady = ref(false)

  useThemeConfig()

  /**
   * This is a workaround to reload the page when the tab is discarded and restored.
   * We do this beacuse the user may experience stale data when the tab is restored.
   */
  document.addEventListener('visibilitychange', async () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { wasDiscarded, visibilityState } = document as any
    if (visibilityState === 'visible') {
      if (wasDiscarded) {
        window.location.reload()
        // You should now reinitialize things like SignalR connections here
      }
    }
  })

  const { modalComponent, modalRef } = provideAppModal()
</script>
<template>
  <LoadingProvider>
    <NotificationProvider>
      <AppContexts>
        <SupportSessionHeader />
        <AppShell>
          <template #app-status-bar> </template>
          <template #main-menu-content>
            <AppMainMenu />
          </template>
          <template #main>
            <router-view v-slot="{ Component }">
              <!-- <keep-alive> -->
              <component :is="Component" />
              <!-- </keep-alive> -->
            </router-view>
          </template>
        </AppShell>
        <component :is="modalComponent" ref="modalRef" />
      </AppContexts>
      <error-dialog />
      <leave-dialog />
    </NotificationProvider>
  </LoadingProvider>
</template>
